import { Container } from '@mui/material';
import { useEffect, useState } from 'react';
import HeaderLayout from '../../../components/Layout/Header/HeaderLayout';
import { BodyTransactions } from '../../../components/myTransactions/BodyTransactions';
import { useGetClientTransactionPortfolio } from '../../../hooks/useGetClientTransactionPortfolio';

const MyTransactionsPages = () => {
  const [tap, setTap] = useState('Fondos');
  const [status, setStatus] = useState(true);
  const [dataTransactionsFiltered, setDataTransactionsFiltered] = useState([]);

  const handleTaps = tap => {
    const isTrue = tap === 'Fondos';
    setTap(tap);
    setStatus(isTrue);
  };

  const {
    data: dataPortfolioTransactions,
    error: errorGetClientTransactionsPortfolio,
    loading: loadingGetClientTransactionsPortfolio,
  } = useGetClientTransactionPortfolio({
    principalAccount: status,
  });

  const succesGetClientTransactionsPortfolio =
    dataPortfolioTransactions?.getClientTransactionPortfolio;

  const fileAs = {
    currency: 'pesos',
    fileAs: 'file as',
    fileAsComplete: 'file as complete',
    risk: 'agresivo',
    profit: '10',
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (!dataPortfolioTransactions) {
      return;
    }
    setDataTransactionsFiltered(succesGetClientTransactionsPortfolio);
  }, [tap, dataPortfolioTransactions, succesGetClientTransactionsPortfolio]);

  return (
    <>
      <HeaderLayout fileAs={fileAs} />
      <Container
        maxWidth='1380px'
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginTop: '8px',
          justifyContent: 'center',
        }}>
        <BodyTransactions
          loadingGetClientTransactionsPortfolio={loadingGetClientTransactionsPortfolio}
          tap={tap}
          handleTaps={handleTaps}
          dataTransactions={dataTransactionsFiltered}
          errorGetClientTransactionsPortfolio={errorGetClientTransactionsPortfolio}
        />
      </Container>
    </>
  );
};

export default MyTransactionsPages;
